export const COPY = {
  es: {
    brandTagline: 'Libreria digital',
    signature: 'Proyecto de Master en Desarrollo de Software - Developed by Pablo Matute.',
    premiumLabel: 'Ediciones premium',
    cartButton: 'Carrito',
    navLinks: [
      { id: 'inicio', label: 'Inicio' },
      { id: 'catalogo', label: 'Catalogo' },
      { id: 'servicios', label: 'Servicios' }
    ],
    heroPill: 'Explora el catalogo',
    heroTitle: 'Tu nueva biblioteca',
    heroHighlightSuffix: 'para lectores exigentes',
    heroSubtitle: 'Encuentra libros, comics y manga seleccionados.',
    heroPrimaryCta: 'Ver destacados',
    heroSecondaryCta: 'Conocer servicios',
    previewPillOne: 'Confianza',
    previewTitleOne: 'Compra segura',
    previewItemsOne: [
      { title: 'Garantia', caption: 'Cambios sin complicaciones' },
      { title: 'Soporte', caption: 'Ayuda personalizada' }
    ],
    previewPillTwo: 'Envios',
    previewTitleTwo: 'Logistica eficiente',
    previewItemsTwo: [
      { title: 'Rastreo', caption: 'Seguimiento en tiempo real' },
      { title: 'Cobertura', caption: 'A todo el pais' }
    ],
    searchPlaceholder: 'Buscar por titulo, autor o categoria...',
    shippingBadge: 'Envio en 24-48h',
    sectionHeading: 'Catalogo',
    sectionDescription: 'Seleccion curada de novedades y clasicos.',
    sectionCta: 'Ver servicios',
    languageLabel: 'Idioma:',
    addToCart: 'Agregar al carrito',
    cardCta: 'Mas detalles',
    emptyState: 'No encontramos resultados para tu busqueda.',
    servicesTitle: 'Nuestros servicios',
    servicesDescription: 'Enfocados en la mejor experiencia de lectura.',
    footerDescription: 'Lectura de calidad para todos.',
    footerCategories: 'Libros - Comics - Manga',
    footerRights: 'Todos los derechos reservados',
    footerLinks: 'Terminos - Privacidad - Ayuda',
    resultSearch: (q) => `Resultados para "${q}"`,
    resultDefault: (n) => `${n} resultados`
  },
  en: {
    brandTagline: 'Digital bookstore',
    signature: 'Proyecto de Master en Desarrollo de Software - Developed by Pablo Matute.',
    premiumLabel: 'Premium editions',
    cartButton: 'Cart',
    navLinks: [
      { id: 'inicio', label: 'Home' },
      { id: 'catalogo', label: 'Catalog' },
      { id: 'servicios', label: 'Services' }
    ],
    heroPill: 'Explore the catalog',
    heroTitle: 'Your new library',
    heroHighlightSuffix: 'for avid readers',
    heroSubtitle: 'Find curated books, comics and manga.',
    heroPrimaryCta: 'See highlights',
    heroSecondaryCta: 'View services',
    previewPillOne: 'Trust',
    previewTitleOne: 'Secure purchase',
    previewItemsOne: [
      { title: 'Warranty', caption: 'Hassle-free returns' },
      { title: 'Support', caption: 'Personalized help' }
    ],
    previewPillTwo: 'Shipping',
    previewTitleTwo: 'Efficient logistics',
    previewItemsTwo: [
      { title: 'Tracking', caption: 'Real-time updates' },
      { title: 'Coverage', caption: 'Nationwide' }
    ],
    searchPlaceholder: 'Search by title, author or category...',
    shippingBadge: 'Shipping in 24-48h',
    sectionHeading: 'Catalog',
    sectionDescription: 'Curated selection of new and classic titles.',
    sectionCta: 'View services',
    languageLabel: 'Language:',
    addToCart: 'Add to cart',
    cardCta: 'Details',
    emptyState: 'No results found for your search.',
    servicesTitle: 'Our services',
    servicesDescription: 'Focused on the best reading experience.',
    footerDescription: 'Quality reading for all.',
    footerCategories: 'Books - Comics - Manga',
    footerRights: 'All rights reserved',
    footerLinks: 'Terms - Privacy - Help',
    resultSearch: (q) => `Results for "${q}"`,
    resultDefault: (n) => `${n} results`
  }
};

export const CATEGORY_TABS = {
  es: [
    { key: 'books', label: 'Libros' },
    { key: 'manga', label: 'Manga' },
    { key: 'comics', label: 'Comics' }
  ],
  en: [
    { key: 'books', label: 'Books' },
    { key: 'manga', label: 'Manga' },
    { key: 'comics', label: 'Comics' }
  ]
};

export const HERO_METRICS = {
  es: [
    { label: 'Titulos', value: '1.2k+' },
    { label: 'Autores', value: '300+' },
    { label: 'Editoriales', value: '120+' }
  ],
  en: [
    { label: 'Titles', value: '1.2k+' },
    { label: 'Authors', value: '300+' },
    { label: 'Publishers', value: '120+' }
  ]
};

export const SERVICE_HIGHLIGHTS = {
  es: [
    { id: 'sec-1', icon: 'ShieldCheck', title: 'Compra protegida', description: 'Pagos seguros y garantia.' },
    { id: 'sec-2', icon: 'Truck', title: 'Envios rapidos', description: 'Entrega a todo el pais.' },
    { id: 'sec-3', icon: 'Sparkles', title: 'Ediciones especiales', description: 'Colecciones exclusivas.' },
    { id: 'sec-4', icon: 'Clock', title: 'Soporte agil', description: 'Atencion en minutos.' }
  ],
  en: [
    { id: 'sec-1', icon: 'ShieldCheck', title: 'Protected purchase', description: 'Secure payments and warranty.' },
    { id: 'sec-2', icon: 'Truck', title: 'Fast shipping', description: 'Nationwide delivery.' },
    { id: 'sec-3', icon: 'Sparkles', title: 'Special editions', description: 'Exclusive collections.' },
    { id: 'sec-4', icon: 'Clock', title: 'Agile support', description: 'Help in minutes.' }
  ]
};

export const CATALOG = {
  books: [
    { id: 'b-hp1', title: 'Harry Potter 1', author: 'J.K. Rowling', price: 16.99, originalPrice: 21.99, cover: '/portadas/libros/harry potter 1.jpg', badge: 'Nuevo', category: 'Fantasia', language: 'ES', format: 'Tapa blanda', rating: 4.8 },
    { id: 'b-hp2', title: 'Harry Potter 2', author: 'J.K. Rowling', price: 16.99, cover: '/portadas/libros/harry potter 2.jpg', category: 'Fantasia', language: 'ES', format: 'Tapa blanda', rating: 4.7 },
    { id: 'b-hp3', title: 'Harry Potter 3', author: 'J.K. Rowling', price: 16.99, cover: '/portadas/libros/harry potter 3.jpg', category: 'Fantasia', language: 'ES', format: 'Tapa blanda', rating: 4.8 },
    { id: 'b-hp4', title: 'Harry Potter 4', author: 'J.K. Rowling', price: 18.99, cover: '/portadas/libros/harry potter 4.jpg', category: 'Fantasia', language: 'ES', format: 'Tapa blanda', rating: 4.8 },
    { id: 'b-hp5', title: 'Harry Potter 5', author: 'J.K. Rowling', price: 18.99, cover: '/portadas/libros/harry potter 5.jpg', category: 'Fantasia', language: 'ES', format: 'Tapa blanda', rating: 4.8 },
    { id: 'b-hp6', title: 'Harry Potter 6', author: 'J.K. Rowling', price: 18.99, cover: '/portadas/libros/harry potter 6.jpg', category: 'Fantasia', language: 'ES', format: 'Tapa blanda', rating: 4.8 },
    { id: 'b-hp7', title: 'Harry Potter 7', author: 'J.K. Rowling', price: 19.99, cover: '/portadas/libros/harry potter 7.jpg', category: 'Fantasia', language: 'ES', format: 'Tapa blanda', rating: 4.9 },
    { id: 'b-fdl', title: 'El fabricante de lagrimas', author: 'Erin Doom', price: 14.99, cover: '/portadas/libros/fabricante de lagrimas.jpg', category: 'Romance', language: 'ES', format: 'Tapa blanda', rating: 4.4 },
    { id: 'b-pri', title: 'El Principito', author: 'Antoine de Saint-Exupery', price: 9.99, cover: '/portadas/libros/principito.jpg', category: 'Clasico', language: 'ES', format: 'Tapa blanda', rating: 4.9 },
    { id: 'b-dune', title: 'Dune', author: 'Frank Herbert', price: 14.99, cover: 'https://m.media-amazon.com/images/I/81ym3QUd3KL.jpg', category: 'Ciencia ficcion', language: 'ES', format: 'Tapa blanda', rating: 4.7 },
    { id: 'b-hobbit', title: 'El Hobbit', author: 'J.R.R. Tolkien', price: 16.2, cover: 'https://m.media-amazon.com/images/I/91b0C2YNSrL._SL1500_.jpg', category: 'Fantasia', language: 'ES', format: 'Tapa dura', rating: 4.8 },
    { id: 'b-hunger', title: 'Los juegos del hambre', author: 'Suzanne Collins', price: 14.8, cover: 'https://m.media-amazon.com/images/I/81MZ8N5c2JL.jpg', category: 'Distopia', language: 'ES', format: 'Tapa blanda', rating: 4.7 },
    { id: 'b-sapiens', title: 'Sapiens', author: 'Yuval Noah Harari', price: 19.99, cover: 'https://m.media-amazon.com/images/I/713jIoMO3UL.jpg', category: 'Historia', language: 'ES', format: 'Tapa blanda', rating: 4.7 }
  ],
  manga: [
    { id: 'm-naruto', title: 'Naruto', author: 'Masashi Kishimoto', price: 9.5, cover: '/portadas/anime/naruto.jpg', category: 'Shonen', language: 'ES', format: 'Tomo', rating: 4.9 },
    { id: 'm-ds', title: 'Demon Slayer', author: 'Koyoharu Gotouge', price: 9.5, cover: '/portadas/anime/demonslayer.jpg', category: 'Shonen', language: 'ES', format: 'Tomo', rating: 4.8 },
    { id: 'm-opm', title: 'One Punch Man', author: 'ONE / Yusuke Murata', price: 9.5, cover: '/portadas/anime/one punch man.jpg', category: 'Accion', language: 'ES', format: 'Tomo', rating: 4.8 },
    { id: 'm-bc', title: 'Black Clover', author: 'Yuki Tabata', price: 9.5, cover: '/portadas/anime/black clover.jpg', category: 'Shonen', language: 'ES', format: 'Tomo', rating: 4.6 },
    { id: 'm-jnk', title: 'Jujutsu Kaisen', author: 'Gege Akutami', price: 9.5, cover: '/portadas/anime/jujutsu kaisen.jpg', category: 'Accion', language: 'ES', format: 'Tomo', rating: 4.8 },
    { id: 'm-snK', title: 'Shingeki no Kyojin', author: 'Hajime Isayama', price: 9.5, cover: '/portadas/anime/shingeki no kioji.jpg', category: 'Accion', language: 'ES', format: 'Tomo', rating: 4.9 },
    { id: 'm-blue-lock', title: 'Blue Lock', author: 'Muneyuki Kaneshiro', price: 11.3, cover: 'https://m.media-amazon.com/images/I/91aj8kYw7fL.jpg', category: 'Shonen', language: 'ES', format: 'Tomo', rating: 4.6 },
    { id: 'm-mha', title: 'My Hero Academia', author: 'Kohei Horikoshi', price: 10.95, cover: 'https://m.media-amazon.com/images/I/81e8xE8fRSL.jpg', category: 'Shonen', language: 'ES', format: 'Tomo', rating: 4.7 },
    { id: 'm-death-note', title: 'Death Note Black Edition', author: 'Tsugumi Ohba', price: 18.5, cover: 'https://m.media-amazon.com/images/I/81f30vIhYvL.jpg', category: 'Seinen', language: 'ES', format: 'Tomo', rating: 4.9 },
    { id: 'm-onepiece', title: 'One Piece', author: 'Eiichiro Oda', price: 9.99, cover: 'https://m.media-amazon.com/images/I/81f37wY8nNL.jpg', category: 'Shonen', language: 'ES', format: 'Tomo', rating: 4.9 }
  ],
  comics: [
    { id: 'c-batman', title: 'Batman', author: 'DC Comics', price: 14.0, cover: '/portadas/comic/batman.jpg', category: 'Superheroes', language: 'EN', format: 'Paperback', rating: 4.6 },
    { id: 'c-spidey', title: 'Spider-Man', author: 'Marvel', price: 14.0, cover: '/portadas/comic/spiderman.jpg', category: 'Superheroes', language: 'EN', format: 'Paperback', rating: 4.7 },
    { id: 'c-super', title: 'Superman', author: 'DC Comics', price: 14.0, cover: '/portadas/comic/superman.jpg', category: 'Superheroes', language: 'EN', format: 'Paperback', rating: 4.6 },
    { id: 'c-wolv', title: 'Wolverine', author: 'Marvel', price: 14.0, cover: '/portadas/comic/wolverine.jpg', category: 'Superheroes', language: 'EN', format: 'Paperback', rating: 4.6 },
    { id: 'c-xmen', title: 'X-Men', author: 'Marvel', price: 14.0, cover: '/portadas/comic/x-men.jpg', category: 'Superheroes', language: 'EN', format: 'Paperback', rating: 4.6 },
    { id: 'c-dead', title: 'Deadpool', author: 'Marvel', price: 14.0, cover: '/portadas/comic/deadppol.jpg', category: 'Superheroes', language: 'EN', format: 'Paperback', rating: 4.5 },
    { id: 'c-v', title: 'V for Vendetta', author: 'Alan Moore', price: 17.9, cover: 'https://m.media-amazon.com/images/I/81vU5L5fMCL.jpg', category: 'Novela grafica', language: 'EN', format: 'Paperback', rating: 4.8 },
    { id: 'c-kj', title: 'The Killing Joke', author: 'Alan Moore', price: 12.99, cover: 'https://m.media-amazon.com/images/I/81w0S3+W7yL.jpg', category: 'Superheroes', language: 'EN', format: 'Paperback', rating: 4.7 },
    { id: 'c-cw', title: 'Civil War', author: 'Mark Millar', price: 16.1, cover: 'https://m.media-amazon.com/images/I/81x6L4Q6M8L.jpg', category: 'Superheroes', language: 'EN', format: 'Paperback', rating: 4.6 },
    { id: 'c-saga', title: 'Saga Vol. 1', author: 'Brian K. Vaughan', price: 14.99, cover: 'https://m.media-amazon.com/images/I/91O1q7FctSL.jpg', category: 'Sci-Fi', language: 'EN', format: 'Paperback', rating: 4.8 }
  ]
};
